<template lang="pug">
.__input_field(:class="{ hasPrefix: dollarIcon }")
  label.label {{ $attrs.name }}
  van-field(
    v-bind="$attrs"
    v-on="$listeners"
    :value="value"
    @input="val => $emit('input', val)"
  )
  .tip(v-if="tip") {{ tip }}

</template>

<script>
export default {
  props: {
    value: [Number, String],
    tip: String,
    dollarIcon: Boolean,
  },
}
</script>

<style lang="sass" scoped>
@use "./vant-field" as *
</style>